import produce from 'immer';
import { AnyAction } from 'redux';
import {
  GET_RECEIPT_DATA_REQUEST,
  GET_RECEIPT_DATA_SUCCESS,
  GET_RECEIPT_DATA_FAILURE,
  GET_RECEIPT_DATA_INITIAL,
} from '../../actions';

// タイプを設定
export type GetReceiptDataStateType = {
  isGetReceiptDataLoading: boolean;
  isGetReceiptDataLoaded: boolean;
  getReceiptData: GetReceiptDataType;
};

type GetReceiptDataType = {
  result: number;
  targetMonthList: number[] | null;
  targetMonthDataMap: { [key: number]: string[] } | null;
};

// ステイタスを初期化
const initialState: GetReceiptDataStateType = {
  isGetReceiptDataLoading: false,
  isGetReceiptDataLoaded: false,
  getReceiptData: {
    result: -1,
    targetMonthList: [],
    targetMonthDataMap: {},
  },
};

// APIの結果によってステイタスが更新される処理
const getReceiptDataReducer = (state = initialState, action: AnyAction): GetReceiptDataStateType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case GET_RECEIPT_DATA_REQUEST:
        dataState.isGetReceiptDataLoading = true;
        dataState.isGetReceiptDataLoaded = false;
        dataState.getReceiptData.result = -1;
        dataState.getReceiptData.targetMonthList = [];
        dataState.getReceiptData.targetMonthDataMap = {};
        break;
      case GET_RECEIPT_DATA_SUCCESS:
        dataState.isGetReceiptDataLoading = false;
        dataState.isGetReceiptDataLoaded = true;
        dataState.getReceiptData.result = action.res.data.result;
        dataState.getReceiptData.targetMonthList = action.res.data.target_month_list;
        dataState.getReceiptData.targetMonthDataMap = action.res.data.target_month_data_map;
        break;
      case GET_RECEIPT_DATA_FAILURE:
        dataState.isGetReceiptDataLoading = false;
        dataState.isGetReceiptDataLoaded = false;
        dataState.getReceiptData.result = -1;
        dataState.getReceiptData.targetMonthList = [];
        dataState.getReceiptData.targetMonthDataMap = {};
        break;
      case GET_RECEIPT_DATA_INITIAL:
        dataState.isGetReceiptDataLoading = false;
        dataState.isGetReceiptDataLoaded = false;
        dataState.getReceiptData.result = -1;
        dataState.getReceiptData.targetMonthList = [];
        dataState.getReceiptData.targetMonthDataMap = {};
        break;
      default:
        break;
    }
  });
};

export default getReceiptDataReducer;
